import apiClient from "../services/apiClient";
import { FetchDataOptions } from "../services/fetchData";

/**
 * Función utilitaria para hacer peticiones HTTP con manejo automático de refresh tokens
 * 
 * @param url - URL de la petición
 * @param options - Opciones de la petición (método, headers, body, etc.)
 * @returns Promise con la respuesta parseada
 * 
 * @example
 * // GET request
 * const userData = await apiRequest<User>('/api/user');
 * 
 * // POST request
 * const result = await apiRequest<ApiResponse>('/api/login', {
 *   method: 'POST',
 *   body: { username, password }
 * });
 */
export const apiRequest = async <T = any>(
  url: string,
  options: Partial<FetchDataOptions> = {}
): Promise<T> => {
  const { method = "GET", headers = {}, body, credentials = "include" } = options;

  try {
    let result: T;

    switch (method.toUpperCase()) {
      case "GET":
        result = await apiClient.get<T>(url, { headers });
        break;
      case "POST":
        result = await apiClient.post<T>(url, body, { headers });
        break;
      case "PUT":
        result = await apiClient.put<T>(url, body, { headers });
        break;
      case "DELETE":
        result = await apiClient.delete<T>(url, { headers });
        break;
      default:
        result = await apiClient.request<T>(url, {
          method: method as any,
          headers,
          body: body ? JSON.stringify(body) : undefined,
        });
        break;
    }

    return result;
  } catch (error) {
    console.error(`API Request failed for ${method} ${url}:`, error);
    throw error;
  }
};

export default apiRequest;